export default __webpack_public_path__ + "static/media/leftScrollIcon.a83540c0.svg";